document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.pagination');
  
  if (target) {
    window.observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && document.querySelector('.pagination .btnLoder')) {
          document.querySelector('.pagination .btnLoder').click();
        }
      });
    });

    window.observer1.observe(target);
    
    window.onClickCollectionPagination = async (link, event) => {
      event.preventDefault();

      link.style.width = `${link.offsetWidth}px`;
      link.style.height = `${link.offsetHeight}px`;
      link.innerHTML = `
        <div class="st-results-loader">
          <div class="result-loading" style="text-align: center">
            <span class="st-spinner">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(255, 255, 255,0); display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(0 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(30 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/></rect></g><g transform="rotate(60 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/></rect></g><g transform="rotate(90 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(120 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/></rect></g><g transform="rotate(150 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/></rect></g><g transform="rotate(180 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/></rect></g><g transform="rotate(210 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/></rect></g><g transform="rotate(240 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/></rect></g><g transform="rotate(270 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/></rect></g><g transform="rotate(300 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/></rect></g><g transform="rotate(330 50 50)"><rect x="48" y="24" rx="2" ry="2.4" width="4" height="12" fill="#000000"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></rect></g><!-- [ldio] generated by https://loading.io/ --></svg>
            </span>
          </div>
        </div>
      `;

      const response = await fetch(link.getAttribute('href'));
      const data = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');

      document.querySelector('.product-grid')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('.product-grid').innerHTML);
      document.querySelector('.pagination')
        .replaceWith(newDocument.querySelector('.pagination'));
      window.observer1.observe(document.querySelector('.pagination'));
    };
  }
});
  function toggleProductGrid(lines) {
    const productGrid = document.getElementById('main-collection-product-grid');
    productGrid.classList.remove('collection__page-products-3');
    productGrid.classList.remove('collection__page-products');
    productGrid.classList.remove('collection__page-products-2');
    productGrid.classList.remove('collection__page-products-1');
    
     if (lines === 2) {
        productGrid.classList.add('collection__page-products-2');
    } else if (lines === 1) {
        productGrid.classList.add('collection__page-products-1');
    }else if (lines === 3) {
        productGrid.classList.add('collection__page-products-3');
    }else if (lines === 4) {
        productGrid.classList.add('collection__page-products');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines);

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active');
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active');
    }
});

}

document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.getElementById('main-collection-product-grid');
    const gridButtons = document.querySelectorAll('.st-grid-changer button');

    if (window.innerWidth <= 768) { 
        gridButtons.forEach(button => {
            const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
            if (buttonColumns === 1) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });
        productGrid.classList.remove('collection__page-products-1');
    }
});

document.addEventListener('DOMContentLoaded', () => {
setTimeout(() => {
  let st_collection_cart_btn = document.querySelectorAll('#collectionmodalcontainer li.grid__item .card--product .card__content');
  if (st_collection_cart_btn.length > 0) {
    st_collection_cart_btn.forEach((button) => {
      if (!button.classList.contains("st-cart-btn")) {
        button.classList.add("st-cart-btn")
        button.innerHTML = button.innerHTML;
      }
    })
  }
}, 600)
});

